import React, { forwardRef, useState, useEffect } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import Popup from 'reactjs-popup';
import Select from "react-select";
import CrossWhite from "../../../assets/images/cross_white.svg";
import CrossBlack from "../../../assets/images/cross_black.svg";
import SearchLogoBlue from "../../../assets/images/search.svg";
import SearchLogoDark from "../../../assets/images/searchGray.svg";
import 'reactjs-popup/dist/index.css';

//forwardRef, For calling child function in Parent component
const RecitationComponent = forwardRef((props, ref) => {

  // State for responsive design
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Get responsive content style based on screen size
  const getResponsiveContentStyle = () => {
    if (isMobile) {
      return {
        display: 'flex',
      };
    }
    return {
      display: 'flex',
      flexDirection: 'column',
      width: 'auto',
      minWidth: '350px',
      maxWidth: '95vw',
      padding: '0.5rem',
      borderRadius: '10px',
      alignItems: 'center',
      background: '#FCFCFC',
      border: '1px solid #DFDFDF',
    };
  };
  return (
      <div className={`mb-auto audio_footer text-center darkBackground `}  >
        <div className='row ml-l-small-device '>
          <div className="col-1">
            {props.recitations && props.recitations.length > 0 && (
              <ReactAudioPlayer
                key={props.audioSrc}
                ref={props.audioRef}
                id="audioPlayer"
                autoPlay={props.playState && !props.translationLoading}
                onPlay={() => props.onAudioPlay && props.onAudioPlay()}
                onEnded={() => {
                  if (parseInt(props.shuffle, 10) === 1) {
                    if (props.audioRef.current && props.audioRef.current.audioEl.current) {
                      props.audioRef.current.audioEl.current.currentTime = 0;
                      props.audioRef.current.audioEl.current.play().catch(error => {
                        console.error("Error replaying audio in repeat single verse:", error);
                      });
                    }
                  } else {
                    props.playNextVerse();
                  }
                }}
                src={props.audioSrc}
                onError={(error) => {
                  console.error("Error in ReactAudioPlayer:", error);
                  // Check if error is network-related
                  if (!navigator.onLine) {
                    // Network error will be handled by the network monitoring in AudioBar.jsx
                    return;
                  }
                  // For other audio errors, show a message
                  if (props.onAudioError) {
                    props.onAudioError(error);
                  }
                }}
              />
            )}
          </div>
          <div className="col-1">
            <img
              className="verse_option_icon cursor_pointer mr-3"
              src={props.shuffle_Icon}
              alt=""
              aria-describedby="popup-37"
              onClick={() => props.setOpenShuffle(o => !o)}
            />
          </div>
          <div className="col-1">
            <img
              className="verse_option_icon cursor_pointer mx-3"
              src={props.movePrevious}
              onClick={() => props.playPreviousVerse()}
              alt=""
            />
          </div>
          <div className="col-1">
            <img
              className="verse_option_icon cursor_pointer mx-3"
              onClick={() => (props.onMainPlayClick ? props.onMainPlayClick() : props.playVerse(props.playingSurah, parseInt(props.shuffle, 10) === 4 ? parseInt(props.rangeOfVerses.fromVerse) : props.playingVerse, !props.playState, false))}
              src={ props.playState ? props.pauseBlackWhite : props.playBlackWhite }
              id="playThisVerse"
              alt=""
            />
          </div>
          <div className="col-1">
            <img
              className="verse_option_icon cursor_pointer mx-3"
              onClick={() => props.playNextVerse()}
              src={props.moveNext}
              alt=""
            />
          </div>

          <div
            className=" col-7 d-flex flex-row cursor_pointer reciter-col"
            aria-describedby="popup-38"
            onClick={() => props.setOpen(o => !o)} 
          >
            <label className={`font-size-14-400 text-pink-blue paddingx-3-0 cursor_pointer text-truncate reciter-label-width`}>
              <span id="reciter-text-label">{props.t('reciter-label')}</span>{props.selectedReciterName}  {props.playState &&  '('+props.selectedSurah +':'+ (props.selectedVerse === 1111 || props.selectedVerse === 0 ? 0 : props.selectedVerse)+')' }
            </label>
            <img
              className="verse_option_icon mx-1 p-1 mt-1 cursor_pointer"
              src={props.arrowDownBlue}
              alt=""
            />
          </div>
          <Popup className='reciter-popup' position="bottom center"
            open={props.open} closeOnDocumentClick onClose={props.closeModal}>
            <div className={`popup-reciter align-items-start darkBackground `} style={{ position: 'relative', maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
              {/* Close button */}
              <img 
                alt={props.t('close')} 
                onClick={() => props.closeModal()} 
                src={props.userTheme === 'Dark' ? CrossWhite : CrossBlack} 
                style={{ 
                  cursor: 'pointer',
                  position: 'absolute',
                  top: '1rem',
                  right: '1rem',
                  left: 'auto',
                  zIndex: 1060,
                  width: '12px',
                  height: '12px',
                  display: 'block'
                }}
              />
              <div className="px-4 pt-3 pb-2">
                <h6 className={`text-white-black-theme mb-2 fw-semibold`}>{props.t('select-reciter-title')}</h6>
              </div>
              <div className="px-4 pb-2">
                <div className="custom-input-container" style={{ width: '100%', maxWidth: '100%' }}>
                  <input 
                    placeholder={props.t('search_here')} 
                    value={props.searchReciterQuery} 
                    onChange={props.handleReciterSearch} 
                    className={`SF_UI_Text search search-bar-background custom-height37 px-3`}
                    type="text"
                    style={{ width: '100%' }}
                  />
                  <img
                    className="menu_icon mx-1 search-icon-custom"
                    alt={props.t('search-alt')}
                    src={props.userTheme === 'Dark' ? SearchLogoDark : SearchLogoBlue}
                  />
                </div>
              </div>
              <div id="ReciterScroll" className="reciters_div-audiobar px-4 pb-3" style={{ height: 'calc(90vh - 140px)', minHeight: 'calc(90vh - 140px)', overflowY: 'auto', flex: '1' }}>
                {props.filteredReciters && props.filteredReciters.length > 0 ? (
                  props.filteredReciters.map((reciter) => (
                    <div key={reciter.id + "reciters"} className="py-1 checkbox-text">
                      <input
                        className="radio-button"
                        type="radio"
                        id={`reciter${reciter.id}`}
                        value={reciter.id}
                        checked={parseInt(props.selectedReciterId) === parseInt(reciter.id)}
                        onChange={() => props.handleReciterChange(reciter.id, reciter.reciter)}
                      />
                      <label className={`p-left-2 radio-label radio-label-audiobar text-white-black-theme `} htmlFor={`reciter${reciter.id}`}>
                        {reciter.reciter}
                      </label>
                    </div>
                  ))
                ) : (
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    height: '100%',
                    minHeight: '90px',
                  }}>
                    <p className={`text-white-black-theme`} style={{ textAlign: 'center', margin: 0 }}>
                      {props.t('no-reciter-available')}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </Popup>
          <Popup
            className='shuffle-popup'
            position="top center"
            offsetY={10}
             contentStyle={getResponsiveContentStyle()}
            open={props.openShuffle} closeOnDocumentClick onClose={props.closeModalShuffle}>
            <div className={`popup-shuffle align-items-start w-auto darkBackground `} style={{ position: 'relative' }}>
              {/* Close button */}
              <img 
                alt={props.t('close')} 
                onClick={() => props.closeModalShuffle()} 
                src={props.userTheme === 'Dark' ? CrossWhite : CrossBlack} 
                style={{ 
                  cursor: 'pointer',
                  position: 'absolute',
                  top: '1rem',
                  right: '1rem',
                  left: 'auto',
                  zIndex: 1060,
                  width: '12px',
                  height: '12px',
                  display: 'block'
                }}
              />
              <div className="py-1 checkbox-text">
                <input
                  className="radio-button"
                  type="radio"
                  id="repeatSingle"
                  value="1"
                  checked={parseInt(props.shuffle) === 1}
                  onChange={() => props.handleShuffleChange(1)}
                />
                <label className={`px-2 radio-label radio-label-audiobar text-white-black-theme`} htmlFor="repeatSingle" onClick={() => props.handleShuffleChange(1)}
                  style={{fontSize: '11px'}}  
                >
                  {props.t('repeat-single-verse')}
                </label>
              </div>
              <div className="py-1 checkbox-text">
                <input
                  className="radio-button"
                  type="radio"
                  id="repeatPage"
                  value="2"
                  checked={parseInt(props.shuffle) === 2}
                  onChange={() => props.handleShuffleChange(2)}
                />
                <label className={`px-2 radio-label radio-label-audiobar text-white-black-theme `} htmlFor="repeatPage" onClick={() => props.handleShuffleChange(2)}
                  style={{fontSize: '11px'}}    
                >
                  {props.t('repeat-chapter')}
                </label>
              </div>
              <div className="py-1 checkbox-text">
                <input
                  className="radio-button"
                  type="radio"
                   id="listenAllChapters"
                  value="3"
                  checked={parseInt(props.shuffle) === 3}
                  onChange={() => props.handleShuffleChange(3)}
                />
                 <label className={`px-2 radio-label radio-label-audiobar text-white-black-theme`} htmlFor="listenAllChapters" onClick={() => props.handleShuffleChange(3)}
                  style={{fontSize: '11px'}}    
                >
                  {props.t('listen-all-chapters')}
                </label>
              </div>
              <div className="py-1 checkbox-text">
                <input
                  className="radio-button"
                  type="radio"
                   id="rangeOfVerses"
                  value="4"
                  checked={parseInt(props.shuffle) === 4}
                  onChange={() => props.handleShuffleChange(4)}
                />
                 <label className={`px-2 radio-label radio-label-audiobar text-white-black-theme`} htmlFor="rangeOfVerses" onClick={() => props.handleShuffleChange(4)}
                  style={{fontSize: '11px'}}
                >
                  {props.t('range-of-verses')}
                </label>
              </div>
               <div className={`mt-3 p-3 border rounded ${props.userTheme === 'Dark' ? 'bg-dark border-secondary' : 'bg-light border-light'}`}>
                 <style>{`
                   #fromVerse:disabled,
                   #toVerse:disabled {
                     background-color: ${props.userTheme === 'Dark' ? '#1a1a1a' : '#f5f5f5'} !important;
                     color: #9ca3af !important;
                     opacity: 0.6 !important;
                     cursor: not-allowed !important;
                   }
                   #fromVerse::placeholder,
                   #toVerse::placeholder {
                     color: #9ca3af !important;
                     opacity: 1;
                   }
                 `}</style>
                 <div className={`text-center mb-3 fw-semibold small ${props.userTheme === 'Dark' ? 'text-white' : 'text-dark'}`}>
                   {props.t('select-range-of-verses')}
                 </div>
                   
                   {/* Row 1: From */}
                   <div className="mb-2">
                     <div className={`fw-medium small ${props.userTheme === 'Dark' ? 'text-white' : 'text-dark'}`}>
                       {props.t('from')}
                     </div>
                   </div>
                   
                   {/* Row 2: From Chapter + From Verse */}
                   <div className="mb-3">
                     <div className="d-flex flex-column flex-md-row gap-2 gap-md-3">
                       <div className="flex-fill w-100" style={{ minWidth: '150px' }}>
                         <label className={`form-label text-white-black-theme small fw-medium`}>
                           {props.t('chapter')}
                         </label>
                         <Select 
                           options={props.ChapterOptions}
                           className={"SF_UI_Text MyDropdown custom-select"}
                            classNamePrefix={"MyDropdown"}
                            isSearchable={false}
                            isDisabled={parseInt(props.shuffle) !== 4}
                            onMenuOpen={props.onMenuOpen}
                            menuPlacement="top"
                                      value={props.selectedOptionFromChapter}
                            onChange={(e) => props.handleChapterChange(e)}
                            placeholder={props.t('select')}
                            components={{
                              SingleValue: ({ children }) => {
                                const isDisabled = parseInt(props.shuffle) !== 4;
                                return (
                                  <span 
                                    style={{ 
                                      color: isDisabled ? '#9ca3af' : 'var(--bs-color)'
                                    }} 
                                    className="ms-2"
                                  >
                                    {children}
                                  </span>
                                );
                              },
                            }}
                            styles={{
                              option: (provided, state) => ({
                                ...provided,
                                          color: state.isSelected ? "white" : "#707070",
                                          backgroundColor: state.isSelected ? (props.userTheme === 'Dark' ? '#FF66B1' : '#E92D71') : 'var(--bs-body-bg)',
                                marginTop: -5, 
                                marginBottom: -5, 
                                "&:hover": {
                                  backgroundColor: 'var(--dropdown-item-hover-bs-color)',
                                  color: state.isSelected ? "white" : "#707070",
                                },         
                              }),
                              valueContainer: (provided, state) => ({
                                ...provided,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                flexWrap: 'nowrap',
                            }),
                            input: (provided, state) => ({
                                ...provided,
                                minWidth: '20%'
                            }),
                            control: (baseStyles, state) => {
                              const isDisabled = parseInt(props.shuffle) !== 4;
                              return {
                                ...baseStyles,
                                width: '100%',
                                height: '40px',
                                borderRadius: '6px',
                                background: isDisabled 
                                  ? (props.userTheme === 'Dark' ? '#1a1a1a' : '#f5f5f5')
                                  : (props.userTheme === 'Dark' ? '#0C0C0C' : '#ffffff'),
                                border: `1px solid ${props.userTheme === 'Dark' ? "#707070" : "#d0d0d0"}`,
                                boxShadow: state.isFocused ? '0 0 0 2px rgba(13, 110, 253, 0.25)' : 'none',
                                opacity: isDisabled ? 0.6 : 1,
                                cursor: isDisabled ? 'not-allowed' : 'default',
                                "&:hover": {
                                  borderColor: isDisabled 
                                    ? (props.userTheme === 'Dark' ? "#707070" : "#d0d0d0")
                                    : (props.userTheme === 'Dark' ? "white" : "#0d6efd"),
                                }
                              };
                            }
                            }}
                         />
                       </div>
                       
                       <div className="flex-fill w-100" style={{ minWidth: '130px' }}>
                         <label className={`form-label text-white-black-theme small fw-medium`}>
                           {props.t('verse')}
                         </label>
                         <input
                           className={`form-control ${props.userTheme === 'Dark' ? 'bg-dark text-white border-secondary' : 'bg-white text-dark border-light'}`}
                           type="number"
                           id="fromVerse"
                           disabled={parseInt(props.shuffle) !== 4}
                           placeholder={(() => {
                             if (!props.selectedOptionFromChapter) {
                               return props.t('enter-verse-number');
                             }
                             const chapterTotalVerses = props.chapters?.chapters?.[props.selectedOptionFromChapter.value - 1]?.totalVerses || 1;
                             return `${props.t('max')}(${chapterTotalVerses})`;
                           })()}
                           min={1}
                           max={props.selectedOptionFromChapter ? props.chapters?.chapters?.[props.selectedOptionFromChapter.value - 1]?.totalVerses || 1 : undefined}
                           value={props.rangeOfVerses.fromVerse || ''}
                           style={{
                             backgroundColor: parseInt(props.shuffle) !== 4 
                               ? (props.userTheme === 'Dark' ? '#1a1a1a' : '#f5f5f5')
                               : (props.userTheme === 'Dark' ? '#0C0C0C' : '#ffffff'),
                             color: parseInt(props.shuffle) !== 4 ? '#9ca3af' : (props.userTheme === 'Dark' ? '#ffffff' : '#000000'),
                             opacity: parseInt(props.shuffle) !== 4 ? 0.6 : 1,
                             cursor: parseInt(props.shuffle) !== 4 ? 'not-allowed' : 'text',
                             border: `1px solid ${props.userTheme === 'Dark' ? '#707070' : '#d0d0d0'}`,
                             borderRadius: '6px',
                             height: '40px'
                           }}
                           onChange={(e) => {
                             const maxVerses = props.selectedOptionFromChapter ? props.chapters?.chapters?.[props.selectedOptionFromChapter.value - 1]?.totalVerses || 1 : 1;
                             const value = e.target.value ? Math.max(1, Math.min(parseInt(e.target.value) || 1, maxVerses)) : '';
                             props.handleFromVerseChange(value);
                           }}
                           onFocus={(e) => {
                             if (parseInt(props.shuffle) === 4) {
                               e.target.style.borderColor = '#0d6efd';
                               e.target.style.boxShadow = '0 0 0 2px rgba(13, 110, 253, 0.25)';
                             }
                           }}
                           onBlur={(e) => {
                             e.target.style.borderColor = props.userTheme === 'Dark' ? '#707070' : '#d0d0d0';
                             e.target.style.boxShadow = 'none';
                           }}
                         />
                       </div>
                     </div>
                   </div>
                   
                   {/* Row 3: To */}
                   <div className="mb-2">
                     <div className={`fw-medium small ${props.userTheme === 'Dark' ? 'text-white' : 'text-dark'}`}>
                       {props.t('to')}
                     </div>
                   </div>
                   
                   {/* Row 4: To Chapter + To Verse */}
                   <div className="mb-3">
                     <div className="d-flex flex-column flex-md-row gap-2 gap-md-3">
                       <div className="flex-fill w-100" style={{ minWidth: '150px' }}>
                         <label className={`form-label text-white-black-theme small fw-medium`}>
                           {props.t('chapter')}
                         </label>
                         <Select 
                          options={props.selectedOptionFromChapter ? 
                            props.ChapterOptions.filter(option => parseInt(option.value, 10) >= parseInt(props.selectedOptionFromChapter.value, 10)) : 
                             props.ChapterOptions}
                           className={"SF_UI_Text MyDropdown custom-select"}
                classNamePrefix={"MyDropdown"}
                isSearchable={false}
                isDisabled={parseInt(props.shuffle) !== 4}
                onMenuOpen={props.onMenuOpen}
                menuPlacement="top"
                           value={props.selectedOptionToChapter}
                onChange={(e) => props.handleChapterToChange(e)}
                placeholder={props.t('select')}
                components={{
                  SingleValue: ({ children }) => {
                    const isDisabled = parseInt(props.shuffle) !== 4;
                    return (
                      <span 
                        style={{ 
                          color: isDisabled ? '#9ca3af' : 'var(--bs-color)'
                        }} 
                        className="ms-2"
                      >
                        {children}
                      </span>
                    );
                  },
                }}
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                               color: state.isSelected ? "white" : "#707070",
                               backgroundColor: state.isSelected ? (props.userTheme === 'Dark' ? '#FF66B1' : '#E92D71') : 'var(--bs-body-bg)',
                    marginTop: -5, 
                    marginBottom: -5, 
                    "&:hover": {
                      backgroundColor: 'var(--dropdown-item-hover-bs-color)',
                      color: state.isSelected ? "white" : "#707070",
                    },         
                  }),
                  valueContainer: (provided, state) => ({
                    ...provided,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    flexWrap: 'nowrap',
                }),
                input: (provided, state) => ({
                    ...provided,
                    minWidth: '20%'
                }),
                  control: (baseStyles, state) => {
                    const isDisabled = parseInt(props.shuffle) !== 4;
                    return {
                      ...baseStyles,
                      width: '100%',
                      height: '40px',
                      borderRadius: '6px',
                      background: isDisabled 
                        ? (props.userTheme === 'Dark' ? '#1a1a1a' : '#f5f5f5')
                        : (props.userTheme === 'Dark' ? '#0C0C0C' : '#ffffff'),
                      border: `1px solid ${props.userTheme === 'Dark' ? "#707070" : "#d0d0d0"}`,
                      boxShadow: state.isFocused ? '0 0 0 2px rgba(13, 110, 253, 0.25)' : 'none',
                      opacity: isDisabled ? 0.6 : 1,
                      cursor: isDisabled ? 'not-allowed' : 'default',
                      "&:hover": {
                        borderColor: isDisabled 
                          ? (props.userTheme === 'Dark' ? "#707070" : "#d0d0d0")
                          : (props.userTheme === 'Dark' ? "white" : "#0d6efd"),
                      }
                    };
                  }
                           }}
                         />
                       </div>
                       
                       <div className="flex-fill w-100" style={{ minWidth: '130px' }}>
                         <label className={`form-label text-white-black-theme small fw-medium`}>
                           {props.t('verse')}
                </label>
                <input
                           className={`form-control ${props.userTheme === 'Dark' ? 'bg-dark text-white border-secondary' : 'bg-white text-dark border-light'}`}
                  type="number"
                  id="toVerse"
                           disabled={parseInt(props.shuffle) !== 4}
                           placeholder={(() => {
                             if (!props.selectedOptionToChapter) {
                               return props.t('enter-verse-number');
                             }
                             const chapterTotalVerses = props.chapters?.chapters?.[props.selectedOptionToChapter.value - 1]?.totalVerses || 1;
                             return `Max(${chapterTotalVerses})`;
                           })()}
                           min={props.selectedOptionFromChapter && props.selectedOptionToChapter && props.selectedOptionFromChapter.value === props.selectedOptionToChapter.value ? 
                             (props.rangeOfVerses.fromVerse || 1) : 1}
                           max={props.selectedOptionToChapter ? props.chapters?.chapters?.[props.selectedOptionToChapter.value - 1]?.totalVerses || 1 : undefined}
                           value={props.rangeOfVerses.toVerse || ''}
                           style={{
                             backgroundColor: parseInt(props.shuffle) !== 4 
                               ? (props.userTheme === 'Dark' ? '#1a1a1a' : '#f5f5f5')
                               : (props.userTheme === 'Dark' ? '#0C0C0C' : '#ffffff'),
                             color: parseInt(props.shuffle) !== 4 ? '#9ca3af' : (props.userTheme === 'Dark' ? '#ffffff' : '#000000'),
                             opacity: parseInt(props.shuffle) !== 4 ? 0.6 : 1,
                             cursor: parseInt(props.shuffle) !== 4 ? 'not-allowed' : 'text',
                             border: `1px solid ${props.userTheme === 'Dark' ? '#707070' : '#d0d0d0'}`,
                             borderRadius: '6px',
                             height: '40px'
                           }}
                           onChange={(e) => {
                             const maxVerses = props.selectedOptionToChapter ? props.chapters?.chapters?.[props.selectedOptionToChapter.value - 1]?.totalVerses || 1 : 1;
                             // Only restrict minimum if both chapters are the same
                             const minVerse = props.selectedOptionFromChapter && props.selectedOptionToChapter && props.selectedOptionFromChapter.value === props.selectedOptionToChapter.value ? 
                               (props.rangeOfVerses.fromVerse || 1) : 1;
                             const value = e.target.value ? Math.max(minVerse, Math.min(parseInt(e.target.value) || minVerse, maxVerses)) : '';
                    props.setRangeOfVerses((prevRange) => ({
                      ...prevRange,
                               toVerse: value,
                             }));
                           }}
                           onFocus={(e) => {
                             if (parseInt(props.shuffle) === 4) {
                               e.target.style.borderColor = '#0d6efd';
                               e.target.style.boxShadow = '0 0 0 2px rgba(13, 110, 253, 0.25)';
                             }
                           }}
                           onBlur={(e) => {
                             e.target.style.borderColor = props.userTheme === 'Dark' ? '#707070' : '#d0d0d0';
                             e.target.style.boxShadow = 'none';
                           }}
                         />
                       </div>
                     </div>
                   </div>
                   
                   {/* Play Button */}
                   <div className="d-flex justify-content-center mt-3 mb-2">
                     <button
                       className={`model_button d-flex align-items-center justify-content-center`}
                       disabled={ parseInt(props.shuffle, 10) !== 4 || !props.selectedOptionFromChapter || !props.selectedOptionToChapter || !props.rangeOfVerses.fromVerse || !props.rangeOfVerses.toVerse }
                       onClick={() => {
                         if (props.selectedOptionFromChapter && props.rangeOfVerses.fromVerse) {
                           // Ensure shuffle mode is set to 4 (range of verses) only if not already set
                           // This prevents unnecessary state updates
                           if (parseInt(props.shuffle) !== 4) {
                             props.handleShuffleChange(4);
                           }
                           
                           // Check if currently playing the exact range
                           const isCurrentlyPlayingRange = parseInt(props.shuffle, 10) === 4 && 
                             props.selectedOptionFromChapter &&
                             props.playingSurah === props.selectedOptionFromChapter.value && 
                             props.playingVerse === parseInt(props.rangeOfVerses.fromVerse) &&
                             props.playState;
                           
                           if (isCurrentlyPlayingRange) {
                             // Pause if currently playing this range
                             props.Pause();
                           } else {
                             // Play the range starting from the selected chapter and verse
                             // Only play if we have valid selections
                             if (props.selectedOptionFromChapter && props.rangeOfVerses.fromVerse) {
                               props.playVerse(
                                 props.selectedOptionFromChapter.value,
                                 parseInt(props.rangeOfVerses.fromVerse),
                                 true,
                                 true
                               );
                             }
                           }
                            // Auto-close shuffle popup after tapping range play/pause.
                            props.closeModalShuffle();
                         }
                       }}
                       style={{
                         backgroundColor: props.userTheme === 'Dark' ? 'var(--bs-body-bg)' : '#F4F4F4',
                         color: props.userTheme === 'Dark' ? 'var(--bs-color)' : '#000',
                         border: props.userTheme === 'Dark' ? 'var(--modal-border)' : 'none',
                         opacity: (!props.selectedOptionFromChapter || !props.selectedOptionToChapter || !props.rangeOfVerses.fromVerse || !props.rangeOfVerses.toVerse || parseInt(props.shuffle, 10) !== 4) ? 0.5 : 1,
                         cursor: (parseInt(props.shuffle, 10) !== 4 || !props.selectedOptionFromChapter || !props.selectedOptionToChapter || !props.rangeOfVerses.fromVerse || !props.rangeOfVerses.toVerse) ? 'not-allowed' : 'pointer',
                         boxShadow: props.userTheme === 'Dark' ? 'var(--modal-button-border)' : 'none',
                         width: '41px',
                         height: '41px',
                         minWidth: '41px',
                         padding: 0
                       }}
                       title={(parseInt(props.shuffle, 10) === 4 && 
                         props.selectedOptionFromChapter &&
                         props.playingSurah === props.selectedOptionFromChapter.value && 
                         props.playingVerse === parseInt(props.rangeOfVerses.fromVerse) &&
                         props.playState) 
                         ? (props.t('pause') || 'Pause')
                         : (props.t('play') || 'Play')}
                     >
                       <img
                         src={
                           (parseInt(props.shuffle, 10) === 4 && 
                            props.selectedOptionFromChapter &&
                            props.playingSurah === props.selectedOptionFromChapter.value && 
                            props.playingVerse === parseInt(props.rangeOfVerses.fromVerse) &&
                            props.playState) 
                           ? props.pauseBlackWhite 
                           : props.playBlackWhite
                         }
                         alt={(parseInt(props.shuffle, 10) === 4 && props.selectedOptionFromChapter && props.playingSurah === props.selectedOptionFromChapter.value && props.playingVerse === parseInt(props.rangeOfVerses.fromVerse) && props.playState) ? props.t('pause-alt') : props.t('play-alt')}
                         style={{ width: '20px', height: '20px' }}
                       />
                     </button>
                   </div>
                   
                   <div className={`text-center small fst-italic ${props.userTheme === 'Dark' ? 'text-light' : 'text-muted'}`}>
                     {props.selectedOptionFromChapter && props.selectedOptionToChapter && props.rangeOfVerses.fromVerse && props.rangeOfVerses.toVerse && 
                       `${props.t('range-label')} ${props.selectedOptionFromChapter.label} (${props.rangeOfVerses.fromVerse}) → ${props.selectedOptionToChapter.label} (${props.rangeOfVerses.toVerse})`
                     }
                     {(!props.selectedOptionFromChapter || !props.selectedOptionToChapter || !props.rangeOfVerses.fromVerse || !props.rangeOfVerses.toVerse) && 
                       props.t('select-chapters-enter-verses')
                     }
                   </div>
               </div>
            </div>
          </Popup>

          {/* Play from Start or Current Verse modal - same UI as app's other dialogs */}
          {props.showPlayFromModal && (
            <div className="modal show" style={{ display: 'block', position: 'fixed', zIndex: 1050, top: 0, left: 0, width: '100%', height: '100%' }} tabIndex="-1" onClick={(e) => e.target.classList.contains('modal') && props.setShowPlayFromModal && props.setShowPlayFromModal(false)}>
              <div className="dark__overlay" onClick={(e) => e.target.classList.contains('dark__overlay') && props.setShowPlayFromModal && props.setShowPlayFromModal(false)} />
              <div className="modal-dialog modal-sm modal-dialog-centered playfrom-modal-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="darkBackground modal-content ModalConfirmationWidth dark-mode-modal-border playfrom-modal-content">
                  <div className="modal-header dark-mode-modal-border-bottom">
                    <div className="d-flex flex-row justify-content-between align-items-center w-100" style={{ height: '3rem' }}>
                      <h6 className="text-white-black-theme model-title-text fw-semibold mb-0 align-self-center">
                        {props.t('play-start-title') || 'Where to start playback?'}
                      </h6>
                      <img className="model-cross-icon align-self-center cursor_pointer" alt="" onClick={() => props.setShowPlayFromModal && props.setShowPlayFromModal(false)} src={props.userTheme === 'Dark' ? CrossWhite : CrossBlack} />
                    </div>
                  </div>
                  <div className="modal-body">
                    <div className="d-flex flex-column">
                      <div className="flex-container custom-column-yes-no playfrom-modal-actions mt-3 justify-content-center align-items-center w-100 h-100">
                        <div onClick={() => props.onPlayFromStart && props.onPlayFromStart()} className="model_button_yes_no darkBackground model_button cursor_pointer text-uppercase">
                          <label className="text-white-black-theme">{props.t('play-from-start') || 'Play from Start'}</label>
                        </div>
                        <div onClick={() => props.onPlayFromCurrentVerse && props.onPlayFromCurrentVerse()} className="model_button_yes_no darkBackground model_button cursor_pointer text-uppercase">
                          <label className="text-white-black-theme">{props.t('play-from-current-verse') || 'Play from Current'} ({props.playFromModalSurah || 1}:{(props.playFromModalVerse === 1111 || props.playFromModalVerse === 0) ? 0 : (props.playFromModalVerse || 1)})</label>
                        </div>
                        <div onClick={() => props.setShowPlayFromModal && props.setShowPlayFromModal(false)} className="model_button_yes_no darkBackground model_button model_button_secondary cursor_pointer text-uppercase">
                          <label className="text-white-black-theme">{props.t('cancel') || 'Cancel'}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
  );
});


export default RecitationComponent;
